import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "input"]
  static values = {
    entryId: Number,
    date: String,
    url: String
  }

  connect() {
    console.log('Group date editor connected')
    console.log('Has display target?', this.hasDisplayTarget)
    console.log('Has input target?', this.hasInputTarget)
    if (this.hasInputTarget) {
      this.inputTarget.value = this.dateValue
    }
  }

  edit() {
    console.log('Edit date clicked!')
    this.displayTarget.style.display = 'none'
    this.inputTarget.style.display = 'inline-block'
    this.inputTarget.focus()
  }

  cancel() {
    this.inputTarget.value = this.dateValue
    this.displayTarget.style.display = 'inline'
    this.inputTarget.style.display = 'none'
  }

  save() {
    const newDate = this.inputTarget.value
    
    if (!newDate || newDate === this.dateValue) {
      this.cancel()
      return
    }

    const formData = new FormData()
    formData.append('finance_entry[checked_at]', newDate)

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      window.location.reload()
    })
    .catch(error => {
      console.error('Error updating date:', error)
      this.cancel()
    })
  }
}

